<div class="video-custom">
  <video
    #videoPlayer
    width="100%"
    height="100%"
    type="video/mp4"
    [src]="url"
    [controls]="toggleFullscreen"
    (click)="onTogglePlay()"
    (dblclick)="onToggleFullscreen()"
  ></video>
  <div *ngIf="showControls || !isPlaying" class="video-custom-controls">
    <div
      (mousedown)="startSeeking($event)"
      class="progress-bar-bg"
      [class.dragging]="isDragging"
      #progressBar
    >
      <div class="progress-bar">
        <div class="progress-bar-fill">
          <div
            class="progress-bar-fill-inner"
            [style.width]="progress + '%'"
            [class.transitioning]="isPlaying && !isDragging"
          >
            <div class="progress-circle"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="controls">
      <div class="content-left">
        <span class="span-time">{{ normalizeTime(currentTime) }}</span>
        <span>/</span>
        <span class="span-time">{{ normalizeTime(durationVideo) }}</span>
      </div>
      <div class="content-center">
        <button
          (click)="backwardVideo()"
          class="control-button"
          data-tooltip="Retroceder (J o ←)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="sizeIcon - 2"
            [attr.height]="sizeIcon - 2"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440h80q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720h-6l62 62-56 58-160-160 160-160 56 58-62 62h6q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80ZM380-320v-60h120v-40H380v-140h180v60H440v40h80q17 0 28.5 11.5T560-420v60q0 17-11.5 28.5T520-320H380Z"
            />
          </svg>
        </button>
        <button
          (click)="onTogglePlay()"
          class="control-button"
          [attr.data-tooltip]="
            togglePlay
              ? 'Pausar (barra espaciadora)'
              : 'Reproducir (barra espaciadora)'
          "
        >
          <svg
            *ngIf="!togglePlay"
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="sizeIcon + 2"
            [attr.height]="sizeIcon + 2"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path d="M293-150v-660l519 330-519 330Z" />
          </svg>
          <svg
            *ngIf="togglePlay"
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="sizeIcon + 2"
            [attr.height]="sizeIcon + 2"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path d="M547.5-175v-610h255v610h-255Zm-390 0v-610h255v610h-255Z" />
          </svg>
        </button>
        <button
          (click)="forwardVideo()"
          class="control-button"
          data-tooltip="Avanzar (L o →)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="sizeIcon - 2"
            [attr.height]="sizeIcon - 2"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-800h6l-62-62 56-58 160 160-160 160-56-58 62-62h-6q-117 0-198.5 81.5T200-440q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440h80q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80ZM380-320v-60h120v-40H380v-140h180v60H440v40h80q17 0 28.5 11.5T560-420v60q0 17-11.5 28.5T520-320H380Z"
            />
          </svg>
        </button>
      </div>
      <div class="content-right">
        <button
          (click)="onToggleMute()"
          class="control-button"
          [attr.data-tooltip]="
            toggleMute ? 'Silenciar (M)' : 'Activar sonido (M)'
          "
        >
          <svg
            *ngIf="!toggleMute"
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="sizeIcon - 2"
            [attr.height]="sizeIcon - 2"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M552-152v-75q86-23 139-93.5T744-480q0-89-53.5-158.5T552-734v-75q116 25 190 117t74 211q0 119-73.5 211.5T552-152ZM144-385v-192h144l192-192v576L288-385H144Zm408 55v-302q45 20 70.5 61t25.5 90q0 49-25.5 89.5T552-330Z"
            />
          </svg>
          <svg
            *ngIf="toggleMute"
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="sizeIcon - 2"
            [attr.height]="sizeIcon - 2"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M768-90 661-197q-22 14-52.5 26.5T552-152v-74q12-5 28.5-11.5T608-250L480-378v187L288-383H144v-192h138L90-768l51-51 678 678-51 51Zm-6-209-52-52q16-29 25-61.5t9-66.5q0-89-53.5-158.5T552-733v-74q117 23 190.5 116T816-479q0 48-14 93.5T762-299ZM638-423l-86-86v-122q45 20 70.5 61.5T648-479q0 14-2 28t-8 28ZM480-581l-93-93 93-93v186Z"
            />
          </svg>
        </button>
        <button
          (click)="onToggleFullscreen()"
          class="control-button button-right"
          [attr.data-tooltip]="
            toggleFullscreen
              ? 'Salir de pantalla completa (F)'
              : 'Pantalla completa (F)'
          "
        >
          <svg
            *ngIf="!toggleFullscreen"
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="sizeIcon - 2"
            [attr.height]="sizeIcon - 2"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M120-120v-320h80v184l504-504H520v-80h320v320h-80v-184L256-200h184v80H120Z"
            />
          </svg>
          <svg
            *ngIf="toggleFullscreen"
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="sizeIcon - 2"
            [attr.height]="sizeIcon - 2"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="m136-80-56-56 264-264H160v-80h320v320h-80v-184L136-80Zm344-400v-320h80v184l264-264 56 56-264 264h184v80H480Z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div
    *ngIf="effectPlay && !effectPause && !isDragging"
    class="effect-play-pause"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="sizeIcon * 2"
      [attr.height]="sizeIcon * 2"
      viewBox="0 -960 960 960"
      fill="currentColor"
    >
      <path d="M312-198.16v-563.68L757.07-480 312-198.16Z" />
    </svg>
  </div>
  <div
    *ngIf="effectPause && !effectPlay && !isDragging"
    class="effect-play-pause"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="sizeIcon * 2"
      [attr.height]="sizeIcon * 2"
      viewBox="0 -960 960 960"
      fill="currentColor"
    >
      <path d="M549-191v-580h202v580H549Zm-340 0v-580h202v580H209Z" />
    </svg>
  </div>
</div>
